import React from 'react'
import styled from 'styled-components'

// Components
import { VerificationNote, StyledVerificationNote } from '../VerificationNote'
import colors from '../../../_constants/colors'

export const S_VerificationNoteList = styled.div`
  .note-list {
    display: flex;
    flex-direction: column;
    max-height: 375px;
    overflow-y: scroll;
  }
  .label {
    margin-bottom: 10px;
    color: ${colors.TEXT_DARK};
    font-weight: 400;
  }
  margin-left: 10px;
  .note {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  ${StyledVerificationNote} {
    background-color: white;
    color: black;
    border-style: solid;
    border-color: #ddd;
    border-width: 1px;
    border-radius: 5px;
  }
  flex-grow: 1;

  .minimalistic-note-list {
    border-radius: 5px;
    border: ${colors.OUTLINE_GREY_BOX} 1px solid;
    margin-top: 10px;
    max-height: 400px;
    min-height: 250px;
    overflow-y: auto;
    padding: 24px;

    ${StyledVerificationNote} {
      border: unset;
      border-radius: 0;
      border-bottom: #ddd 1px solid;
    }
  }
`

export const VerificationNoteList = ({ label, verifications, noteStyle = '' }) => {
  const renderNote = (verification) => {
    return <VerificationNote verification={verification} />
  }
  return (
    <S_VerificationNoteList>
      <h3 className="label">{label}</h3>
      <div className={'minimalistic-note-list'}>
        {verifications.map((v, i) => (
          <div className={'note'} key={v.id}>
            {renderNote(v)}
          </div>
        ))}
      </div>
    </S_VerificationNoteList>
  )
}
